import { landingFunnelKey } from "@/constants/funnelRouteDeclareValues";
import useFunnelRouteDeclare from "@/hooks/useFunnelRouteDeclare";
import useLandingPageEffect from "@/hooks/useLandingPage";
import {
  BaseMobileLayout,
  colors,
  customEvent,
  getCdnImageSrc,
  kakaoPixel,
  pixelCustomEvent,
  PixelEventName,
  RenewalFooter,
  Spacing,
  tossPixel,
  VLine,
} from "goi_common";
import GlobalCollaborationSection from "goi_common/src/components/Prime/GlobalCollaborationSection";
import { Box } from "@chakra-ui/react";
import {
  HomeV4HeroSection,
  HomeV4YoutubeVerticalSection,
  HomeV4GoiIntroSection,
  HomeV4PRSection,
  HomeV4CTASection,
} from "@/containers/HomeV4/components";
import { naverConversionEvent } from "@/utils/naverPageView";
import FixedSubmitButton from "@/components/common/FixedSubmitButton";
import useLandingPageScroll from "@/hooks/useLandingPageScroll";
import { useRouter } from "next/router";
import { useCustomFeature } from "@/hooks/useCustomFeature";
import { PRODUCT_GROUP } from "@/constants/productKey";

export default function Promotion26UpAContainer() {
  const router = useRouter();
  const { paths } = useFunnelRouteDeclare({
    uniqueKey: landingFunnelKey.GROUP["promotion_26_up_a"],
  });

  const feature = useCustomFeature(25);

  useLandingPageEffect();

  useLandingPageScroll({
    verificationHref: `${paths.verification}`,
  });

  const handleCtaClick = (
    trigger_and_target: "fixed_CTA" | "hero_CTA-uv_registration" | "section_CTA"
  ) => {
    // 기존 대시보드 유지를 위한 home 이벤트
    customEvent({
      newGtm: {
        path: "home",
        trigger_and_target: "CTA",
      },
    });

    customEvent({
      newGtm: {
        path: "home",
        trigger_and_target,
      },
    });

    // 별도 프로모션 성과 측정을 위한 promotion 이벤트
    customEvent({
      newGtm: {
        path: "promotion",
        trigger_and_target: "CTA",
      },
    });

    customEvent({
      newGtm: {
        path: "promotion",
        trigger_and_target,
      },
    });

    naverConversionEvent({ type: "view_product" });
    kakaoPixel()?.participation();
    tossPixel()?.productView();
    pixelCustomEvent(PixelEventName.ViewContent);

    router.push(
      paths["verification"] ||
        `/registration/verification/?productGroup=${PRODUCT_GROUP.mt}`
    );
  };

  return (
    <BaseMobileLayout padding="0px">
      <HomeV4HeroSection
        title={`월 9,900원 상조\n추가 가입시 3가지 혜택을 드려요`}
        description="2024년 100원 가입자 전용 설날 이벤트"
        imageSrc={getCdnImageSrc("direct/home/money_shield_concept.png")}
        buttonText="시작하기"
        onClick={() => {
          handleCtaClick("hero_CTA-uv_registration");
        }}
        disabled={!feature}
      />

      <Box width="100%">
        <Box
          as="img"
          src={getCdnImageSrc(
            "direct/promotion/crm-9900/crm_9900_notice-1.png"
          )}
          alt="혜택 안내"
          width="100%"
          display="block"
        />
      </Box>

      <HomeV4YoutubeVerticalSection
        youtubeUrl="https://youtube.com/shorts/MNFJ78HQHoc?si=LamPa6VeFmrQJoRS"
        description={
          <>
            고이 대표님이 직접 알려드려요.
            <br />
            보장 금액은 <b>259만원(2024 기준)으로 동일</b>해요.
            <br />
            고객님 상황에 맞게 납입 방식만 선택하세요.
          </>
        }
      />

      {/* <HomeV4YoutubeSection /> */}
      {/* <VLine width="100%" height="16px" color={colors.gray50} /> */}
      <Box width="100%" padding="0 20px">
        {/* 첫 번째 이미지 */}
        <Box
          as="img"
          src={getCdnImageSrc(
            "direct/promotion/crm-9900/crm_9900_259_benefit-1.png"
          )}
          alt="혜택 안내"
          width="100%"
          display="block"
        />

        {/* 두 번째 이미지 (버튼) */}
        <Box
          as="img"
          src={getCdnImageSrc(
            "direct/promotion/crm-9900/crm_9900_benefit_button.png"
          )}
          alt="혜택 받기"
          width="100%"
          display="block"
          cursor="pointer"
          onClick={() => {
            if (!feature) return;
            customEvent({
              newGtm: {
                path: "home",
                trigger_and_target: "CTA-promotion_button",
              },
            });
            customEvent({
              newGtm: {
                path: "promotion",
                trigger_and_target: "CTA-promotion_button",
              },
            });
            // TODO: 26-up-a 페이지로 이동
            router.push("/memorialtable/?utm_source=promotion_26_up_a");
          }}
        />

        <Spacing gap={60} />

        {/* 세 번째 이미지 */}
        <Box
          as="img"
          src={getCdnImageSrc(
            "direct/promotion/crm-9900/crm_9900_259_description-memorial.png"
          )}
          alt="상세 설명"
          width="100%"
          display="block"
        />
      </Box>

      <HomeV4GoiIntroSection />
      <GlobalCollaborationSection
        top={
          <>
            <Box className="body_16_r gray700">믿을 수 있는 파트너</Box>
            <Spacing gap={8} />
            신뢰도 높은 기관들과 함께
            <br />
            상조 서비스를 혁신하고 있습니다
          </>
        }
      />
      <HomeV4PRSection />

      <HomeV4CTASection
        onClick={() => {
          handleCtaClick("section_CTA");
        }}
        disabled={!feature}
      />
      <VLine width="100%" height="1px" color={colors.gray200} />
      <RenewalFooter />

      <FixedSubmitButton
        onClick={() => {
          handleCtaClick("fixed_CTA");
        }}
        disabled={!feature}
      >
        고이와 함께 장례 준비 시작하기
      </FixedSubmitButton>
    </BaseMobileLayout>
  );
}
